import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_express } from "./shared/data.service";
import { wsOneCardExpressDataInfo } from "./shared/wsOneCardExpressDataInfo";
import { wsIDDepotPrintQueueInfo } from "./shared/wsOneCardExpressDataInfo";
import { wsIDDepotPrintQueueHistoryInfo } from "./shared/wsOneCardExpressDataInfo";

import { wsPrintQueueValidateAddInfo } from "./shared/wsPrintQueueValidateAddInfo";
import { wsPrintQueueInsertParm } from "./shared/wsPrintQueueInsertParm";

import { wsPrintQueueDeleteParm } from "./shared/wsPrintQueueDeleteParm";
import { wsDeleteInfo } from "./shared/wsPrintQueueDeleteParm";

import { wsPrintQueuePrintParm } from "./shared/wsPrintQueuePrintParm";
import { wsPrintInfo } from "./shared/wsPrintQueuePrintParm";

import { AddComponent } from "./add/add.component";
import { ViewChild } from "@angular/core";

@Component({
	selector: "app-root",
	templateUrl: "./express.component.html",
	styleUrls: ["./express.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class ExpressComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("mydthist") mydthist: Table;

	constructor(
		private datepipe: DatePipe,
		private dataService: DataService_express,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private personselectorService: PersonSelectorService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	private subscriptionSchoolSelect: Subscription;

	public SelectedPerson: any; // From Person Selector
	public SelectedSchool: any; // From Person Selector
	public PrevSelectedSchool: any;

	//	PrintQ List
	public rOneCardExpressData: wsOneCardExpressDataInfo;
	public lstPrintQueue: wsIDDepotPrintQueueInfo[] = [];
	public lstPrintQueueHistory: wsIDDepotPrintQueueHistoryInfo[] = [];
	public rPrintQueueItem: wsIDDepotPrintQueueInfo;
	public lstPrintQueueChecked: wsIDDepotPrintQueueInfo[] = [];

	//	PrintQ Counts
	public SchoolTotalPrinted: number = 0;
	public SchoolPrintedToday: number = 0;
	public SchoolTotalSubmitted: number = 0;
	public SubmitCutoffTime: Date;
	public IsExpressSchool: boolean = true;

	public pagefirst: number = 0;
	public pagerows: number = 25;

	public historypagefirst: number = 0;
	public historypagerows: number = 25;

	public PublicTransitLabel: string = "MTA";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
		});

		this.subscriptionSchoolSelect = this.personselectorService.onSchoolSelectedChange().subscribe((school) => {
			let isSchoolChange: boolean = false;

			this.PrevSelectedSchool = this.SelectedSchool;
			this.SelectedSchool = school;

			if (this.PrevSelectedSchool == null || this.PrevSelectedSchool.SchoolID != this.SelectedSchool.SchoolID) {
				isSchoolChange = true;
			}

			if (isSchoolChange == true && this.SelectedSchool.SchoolID > 0) {
				this.isBusy = true;
				this.dataService.OneCardExpressDataGet(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
			}
		});

		this.dataService.PublicTransitPreferenceSelect().subscribe((data: any) => {
			if (data.Success == true) {
				this.PublicTransitLabel = data.ErrorMessage;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
		this.subscriptionSchoolSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.isBusy = true;
		this.dataService.OneCardExpressDataGet(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSelectList_Complete(data: any) {
		this.rOneCardExpressData = data;

		this.lstPrintQueueChecked = [];
		this.SchoolTotalPrinted = this.rOneCardExpressData.SchoolTotalPrinted;
		this.SchoolPrintedToday = this.rOneCardExpressData.SchoolPrintedToday;
		this.SchoolTotalSubmitted = this.rOneCardExpressData.SchoolTotalSubmitted;
		this.SubmitCutoffTime = this.rOneCardExpressData.SubmitCutoffTime;
		this.IsExpressSchool = this.rOneCardExpressData.IsExpressSchool;
		this.lstPrintQueue = this.rOneCardExpressData.PrintQueueItems;
		this.lstPrintQueueHistory = this.rOneCardExpressData.PrintQueueHistoryItems;

		this.mydt.reset(); // Reset Sort
		this.mydthist.reset(); // Reset Sort

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAdd
	//
	//-----------------------------------------------------------------------------------------------------
	onAdd() {
		if (this.SelectedPerson == null || this.SelectedPerson.PersonID === undefined || this.SelectedPerson.PersonID <= 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "No student selected. Please select a student.",
				header: "Add",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		} else {
			this.isBusy = true;
			this.dataService.IDPrintQueueValidateAdd(this.SelectedPerson.PersonID).subscribe((data) => this.IDPrintQueueValidateAdd_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueValidateAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueValidateAdd_Complete(data: any) {
		let rPrintQueueValidateAdd: wsPrintQueueValidateAddInfo;
		rPrintQueueValidateAdd = data;
		this.isBusy = false;

		let EnableOverrideMode: boolean = false;
		let EnableReprintMode: boolean = false;

		if (this.user.personID == 0 && rPrintQueueValidateAdd.IsMTARider == false) {
			let message: string =
				"Can't continue. <br><br>" +
				this.SelectedPerson.PersonName +
				" is not a valid " +
				this.PublicTransitLabel +
				" Rider. <br><br>Note: SU can only add " +
				this.PublicTransitLabel +
				" riders in OneCard Express.";

			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: message,
				header: "Add Submit Item",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		if (rPrintQueueValidateAdd.HasSubmitItem == true) {
			let message: string = "Can't re-add. <br><br>A submit item already exists for " + this.SelectedPerson.PersonName;

			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: message,
				header: "Add Submit Item",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		if (rPrintQueueValidateAdd.HasPrintPendingItem == true) {
			let message: string =
				"Can't re-add. <br><br>A print request for " +
				this.SelectedPerson.PersonName +
				" is being processed. The request was subitted on " +
				rPrintQueueValidateAdd.LastPrintPendingDTDesc;

			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: message,
				header: "Add Submit Item",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		//
		//	PROCESS - Determine course of action, popup or no popup.
		//
		if (rPrintQueueValidateAdd.IsMTARider == true) {
			EnableOverrideMode = false;
		} else {
			EnableOverrideMode = true;
		}

		if (rPrintQueueValidateAdd.HasPrintedItem == true || rPrintQueueValidateAdd.HasFailedItem == true) {
			EnableReprintMode = true;
		} else {
			EnableReprintMode = false;
		}

		if (EnableOverrideMode == true || EnableReprintMode == true) {
			//
			//	Validate Add Popup Needed
			//
			let title: string = "Override " + this.PublicTransitLabel + " Rider Status / Reprint Reason";

			if (EnableOverrideMode == true && EnableReprintMode == false) {
				title = "Override " + this.PublicTransitLabel + " Rider Status";
			}

			if (EnableOverrideMode == false && EnableReprintMode == true) {
				title = "Reprint Reason";
			}

			var ref = this.dialogService.open(AddComponent, {
				header: title,
				width: "500px",
				data: {
					UserPersonID: this.user.personID,
					SchoolID: this.SelectedSchool.SchoolID,
					PersonID: this.SelectedPerson.PersonID,
					StudentID: this.SelectedPerson.DesignatorID,
					PersonName: this.SelectedPerson.PersonName,
					EnableOverrideMode: EnableOverrideMode,
					EnableReprintMode: EnableReprintMode,
					IsMTARider: rPrintQueueValidateAdd.IsMTARider,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.isBusy = true;
					this.dataService.OneCardExpressDataGet(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
				}
			});
		} else {
			//
			//	No Validate Popup Needed
			//
			let parms: wsPrintQueueInsertParm = {
				PersonID: this.SelectedPerson.PersonID,
				IDDepotPrintReasonID: 11, // New Card
				AdministratorPersonID: this.user.personID,
			};

			this.isBusy = true;
			this.dataService.IDPrintQueueAdd(parms).subscribe((data) => this.IDPrintQueueAdd_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueAdd_Complete(data: any) {
		//
		//	Refresh Q
		//
		this.isBusy = false;
		this.dataService.OneCardExpressDataGet(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleHistorySort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleHistorySort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDelete
	//
	//-----------------------------------------------------------------------------------------------------
	onDelete() {
		//
		// Validate Delete PrintQ Items
		//
		if (this.lstPrintQueueChecked.length < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no selected items in the print queue.",
				header: "Remove",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});

			return;
		} else {
			//
			// Confirm Delete
			//
			var strWork = "";

			if (this.lstPrintQueueChecked.length == 1) {
				strWork = "Item";
			} else {
				strWork = "Items";
			}

			var message =
				"You are about to remove " +
				this.lstPrintQueueChecked.length +
				" " +
				strWork +
				" " +
				"from the print queue.<br><br>" +
				"Do you wish to continue?";

			this.confirmationService.confirm({
				message: message,
				header: "Remove",
				icon: "fa fa-info",
				accept: () => {
					this.onDeleteConfirmed();
				},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onDeleteConfirmed
	//
	//-----------------------------------------------------------------------------------------------------
	onDeleteConfirmed() {
		let parms: wsPrintQueueDeleteParm = {
			DeleteItems: [],
		};

		this.lstPrintQueueChecked.forEach((item) => {
			let r: wsDeleteInfo = {
				IDDepotPrintQueueID: item.IDDepotPrintQueueID,
			};

			parms.DeleteItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueueDelete(parms).subscribe((data) => this.IDPrintQueueDelete_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueDelete_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueDelete_Complete(data: any) {
		this.isBusy = false;
		this.dataService.OneCardExpressDataGet(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		//
		//	Make Sure We Have Cards To Print
		//
		if (this.lstPrintQueue.length == 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "There are no items in the list to submit.",
				header: "Submit To Queue",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		//
		//	Print The Cards
		//
		let now = new Date();
		let IsAfterCutOffTime: boolean = false;
		let strCutOffTime: string = "";
		let message: string = "";
		let header: string = "Submit " + this.lstPrintQueue.length + " Item(s) To Queue";

		strCutOffTime = this.datepipe.transform(this.SubmitCutoffTime, "h:mm a");

		if (new Date(now).getTime() > new Date(this.SubmitCutoffTime).getTime()) {
			IsAfterCutOffTime = true;
		}

		if (IsAfterCutOffTime == true) {
			message =
				"The cutoff time is set to " +
				strCutOffTime +
				", submitted cards before this time will be printed and shipped today, " +
				"cards submitted afterwards will ship the next business day." +
				"<br><br>" +
				"Action will submit all " +
				this.lstPrintQueue.length +
				" item(s) and cannot be reversed. All items will be cleared from list." +
				"<br><br>" +
				"Continue with submit?";
		} else {
			message =
				"Action will submit all " +
				this.lstPrintQueue.length +
				" item(s) and cannot be reversed. All items will be cleared from list." +
				"<br><br>" +
				"Continue with submit?";
		}

		this.confirmationService.confirm({
			message: message,
			header: header,
			icon: "fa fa-info",
			accept: () => {
				this.onPrintConfirm();
			},
			reject: () => {},
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrintConfirm
	//
	//-----------------------------------------------------------------------------------------------------
	onPrintConfirm() {
		let parms: wsPrintQueuePrintParm = {
			PrintItems: [],
		};

		this.lstPrintQueue.forEach((item) => {
			let r: wsPrintInfo = {
				IDDepotPrintQueueID: item.IDDepotPrintQueueID,
				IDDepotPrintReasonID: item.IDDepotPrintReasonID,
				AdministratorPersonID: this.user.personID,
			};

			parms.PrintItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueuePrint(parms).subscribe((data) => this.IDPrintQueuePrint_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueuePrint_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueuePrint_Complete(data: any) {
		this.isBusy = false;
		this.dataService.OneCardExpressDataGet(this.SelectedSchool.SchoolID).subscribe((data) => this.IDPrintQueueSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
